module.exports = __webpack_public_path__ + "img/sld_ch_9_t1_green.7d789bfd.svg";